import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./router"; // MOD
import reportWebVitals from "./reportWebVitals";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";
import { CoreState } from "./context/CoreContext";
import ModalCore from "components/NewModal/Core";
import CarouselModal from "components/CarouselModal"; // Import do Carrossel

// Obter o elemento root
const rootElement = document.getElementById("root");

// Criar o root usando a nova API createRoot
const root = createRoot(rootElement);

// Renderizar o aplicativo
root.render(
  <React.StrictMode>
    <CoreState>
      <App />
      <ModalCore />
      <CarouselModal /> {/* Adiciona o carrossel ao fluxo */}
      <ToastContainer />
    </CoreState>
  </React.StrictMode>
);

// Medir performance do aplicativo
reportWebVitals();
